<script setup lang="ts">
defineProps<{
  filterItems: string[]
  isFilterActive: (item: string) => boolean
  trajectLabels: string[]
  groupFilterLabel: string
  isGroupFilterActive: (group: string) => boolean
}>()

const emit = defineEmits<{
  toggleFilter: [item: string]
  toggleGroupFilter: [group: string]
}>()
</script>

<template>
  <v-card class="outlined-card">
    <v-card-title class="py-3 text-subtitle-2">Filters</v-card-title>
    <v-divider />
    <v-card-text class="py-2 scrollable-chart">
      <div class="text-caption text-medium-emphasis mb-1">Material</div>
      <v-checkbox
        v-for="item in filterItems"
        :key="item"
        :label="item"
        :model-value="isFilterActive(item)"
        @update:model-value="emit('toggleFilter', item)"
        density="compact"
        hide-details
        class="my-1"
      />
      <template v-if="trajectLabels.length > 0">
        <v-divider class="my-3" />
        <div class="text-caption text-medium-emphasis mb-1">{{ groupFilterLabel }}</div>
        <v-checkbox
          v-for="group in trajectLabels"
          :key="group"
          :label="group"
          :model-value="isGroupFilterActive(group)"
          @update:model-value="emit('toggleGroupFilter', group)"
          density="compact"
          hide-details
          class="my-1"
        />
      </template>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.outlined-card {
  border: 1px solid #c0c0c0;
  border-radius: 10px;
}

.scrollable-chart {
  overflow-x: auto;
  height: 63vh;
}
</style>
